import { render, staticRenderFns } from "./RelatedOrderStatusSpan.vue?vue&type=template&id=0af35039&scoped=true&"
import script from "./RelatedOrderStatusSpan.vue?vue&type=script&lang=js&"
export * from "./RelatedOrderStatusSpan.vue?vue&type=script&lang=js&"
import style0 from "./RelatedOrderStatusSpan.vue?vue&type=style&index=0&id=0af35039&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af35039",
  null
  
)

export default component.exports